import mitsuketa from 'mitsuketa'

const SET_ITEMS = (state, items) => {
  state.items = items
}

const SET_ITEM = (state, item) => {
  state.item = item
}

const SET_BUILDING = (state, value) => {
  state.building = value
}

const PUSH = (state, item) => {
  item.bundles = []
  item.children = []
  item.users = []

  if (item.item_id) {
    let parent = mitsuketa.deepGet(state.items, { id: item.item_id })
    parent.children.push(item)
    return
  }

  state.items.push(item)
}

const UPDATE = (state, data) => {
  mitsuketa.deepGet(state.items, { id: data.id }).name = data.name
}

const REMOVE = (state, itemId) => {
  const findAndRemoveItem = (items) => {
    items.forEach((item, idx) => {
      if (item.id === itemId) {
        items.splice(idx, 1)
        return
      }

      findAndRemoveItem(item.children)
    })
  }

  findAndRemoveItem(state.items)
}

const PUSH_GRANT = (state, params) => {
  const item = findItem(state, params)
  item.users.push(params.user)
}

const REVOKE_GRANT = (state, params) => {
  const item = findItem(state, params)
  const idx = item.users.findIndex(x => x.id === params.userId)

  item.users.splice(idx, 1)
}

const INCLUDE_BUNDLE = (state, params) => {
  const item = findItem(state, params)
  item.bundles.push(params.bundle)
}

const EXCLUDE_BUNDLE = (state, params) => {
  const item = findItem(state, params)
  const idx = item.bundles.findIndex(x => x.id === params.bundleId)

  item.bundles.splice(idx, 1)
}

const RESET = (state) => {
  state.item = null
}

const findItem = (state, params) => {
  const search = (items) => {
    return items.find((x) => {
      if (x.id === params.itemId) {
        item = x
      } else {
        search(x.children)
      }
    })
  }

  let item = null

  search(state.items)

  return item
}

export default {
  PUSH,
  RESET,
  UPDATE,
  REMOVE,
  SET_ITEM,
  SET_ITEMS,
  PUSH_GRANT,
  REVOKE_GRANT,
  SET_BUILDING,
  INCLUDE_BUNDLE,
  EXCLUDE_BUNDLE
}
